import { DEFAULT_STATISTICS_DATE_FORMAT } from "../common/values";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface TooltipOptions {
  percent?: boolean;
}

interface TooltipCtx {
  series: number[][];
  seriesIndex: number;
  dataPointIndex: number;
  w: any;
}

/**
 * Facrory of tooltip’а ApexCharts.
 * Call createChartTooltip({ percent: true }) --> value with  %
 */

export const createChartTooltip = ({
  percent = false,
}: TooltipOptions = {}): ApexTooltip => ({
  custom: ({ series, seriesIndex, dataPointIndex, w }: TooltipCtx) => {
    const hidden = new Set<number>(
      (w.globals.collapsedSeriesIndices || []).map(Number)
    );

    const hoverX: number = w.globals.seriesX[seriesIndex][dataPointIndex];
    const hoverIndexes: number[] = w.globals.seriesX.map((sx: number[]) =>
      sx.indexOf(hoverX)
    );

    let hoverList = "";

    hoverIndexes.forEach((hIdx: number, sIdx: number) => {
      if (hIdx < 0 || hidden.has(sIdx)) return;

      const raw: number = series[sIdx][hIdx];
      let val: string | number =
        w.globals.yLabelFormatters?.[0]?.(raw) ?? raw ?? 0;

      if (val === 0) return;

      if (typeof val === "string" && val.includes("null")) return;

      if (percent && !String(val).includes("%")) val = `${val}%`;

      hoverList += `
        <div class="apexcharts-tooltip-series-group apexcharts-active" style="display:flex;">
          <span class="apexcharts-tooltip-marker"
                style="background-color:${w.globals.markers.colors[sIdx]};
                       border-radius:50%;width:12px;height:12px;"></span>
          <div class="apexcharts-tooltip-text">
            <div class="apexcharts-tooltip-y-group">
              <span class="apexcharts-tooltip-text-y-label">${w.globals.seriesNames[sIdx]}:</span>
              <span style="font-weight:700;">${val}</span>
            </div>
          </div>
        </div>`;
    });

    const formats: (string | undefined)[] = [
      dayjs.utc(new Date(hoverX)).format(DEFAULT_STATISTICS_DATE_FORMAT),
      dayjs
        .utc(new Date(w.globals.labels[dataPointIndex]))
        .format(DEFAULT_STATISTICS_DATE_FORMAT),
      w.globals.categoryLabels?.[dataPointIndex],
    ];

    let date: string | undefined = formats.find(d => d && !d.includes("70"));

    if (dayjs().format(DEFAULT_STATISTICS_DATE_FORMAT) === date) {
      date = "Today";
    }

    return `
      ${hoverList}
      <hr style="margin-top:-2px;">
      <div class="tooltip-date">${date}</div>
    `;
  },
});
